export const duplicatesCardInfo = {
	dueDate: "Due date",
	subtitle: "Duplicate",
	title: "Duplicates",
	value: "Value",
};
